"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.MergeCells = void 0;
var _mergeCells = require("./mergeCells");
exports.PLUGIN_KEY = _mergeCells.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _mergeCells.PLUGIN_PRIORITY;
exports.MergeCells = _mergeCells.MergeCells;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/mergeCells/index.js
// module id = 1487
// module chunks = 0